const styles = theme => ({

    dashboardText2: {
        color: 'var(--b, #FFF) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    datePickerWrapper: {
        marginLeft: '10px'
    },

    // From the line 17 changes has been done by Dev srini on 07/08/24
    datePicker: {
        width: '190px', //dev-trupti on 24-12-2024
        backgroundColor: '#131E2E ! important',
        // This targets the root element of the InputBase component inside the DatePicker component. It sets the text color to white (#FFFFFF).
        '& .MuiInputBase-root': {
            color: '#fff ! important',
            height: '40px', //dev-trupti on 24-12-2024
            padding: '6px 10px',
        },
        '& .MuiInputLabel-root': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
            fontStyle: 'normal',
        },
        '& .MuiSvgIcon-root': {
            color: '#fff ! important',
        },
        //dev-trupti on 24-10-2024
        // '@media screen and (max-width: 1620px)' : {
        //     width: '210px',
        //   }
        //dev-trupti on 24-12-2024
        "@media only screen and (max-width: 1620px)": {
            width: '190px !important'
        },
        "@media only screen and (max-width: 1420px)": {
            width: '180px !important'
        },
        "@media only screen and (max-width: 1350px)": {
            width: '170px !important'
        },
    },

    kycFilterfield: {
        display: 'flex',
        // marginLeft: '10px',
        marginBottom: '10px',
    },

    kycFormDateField: {
        display: 'flex',
        marginTop: '25px',
        marginRight: '20px',
        marginBottom: '10px'
    },

    kycFormInputField: {
        display: 'flex',
        marginRight: '20px',
        marginBottom: '10px',
        marginLeft: '-9%'
    },

    horizantalTablayout: {
        width: '100% !important', //dev-trupti on 23-10-2024
        // flexShrink: 0,
        borderRadius: '10px',
        background: '#131E2E ! important',
        // overflowY: 'auto',
        height: '80vh' // Srini - 12/11/24
    },

    customDataGrid: {
        '& .MuiDataGrid-columnHeaders': {
            color: '#747474 !important',
            fontFamily: 'cardiuma-M ! important',
            fontSize: '13px ! important',
            fontWeight: '600 ! important',
            lineHeight: '18px ! important',

        },

        '& .MuiDataGrid-cell': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '12px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
            borderBottom: '1.5px solid black ! important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff ! important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff ! important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },
        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '13px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSelect-icon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none ! important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E ! important',
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '14   px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSvgIcon-root': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff ! important',
        }
    },

    tableHeading: {
        width: 'auto',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important'
    },

    rowText: {
        color: 'var(--b, #FFF)  ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px  ! important',
        fontStyle: 'normal',
        fontWeight: '400  ! important',
        lineHeight: '18px  ! important'
    },

    checkBox: {
        color: "#fff ! important",
        marginRight: '110px',
        marginLeft: '-98px',
        '& .MuiCheckbox-root': {
            color: '#fff ! important'
        },
    },
    checkBoxNew: { //dev-trupti on 26-12-2024
        color: "#fff ! important",
        '& .MuiCheckbox-root': {
            color: '#fff ! important'
        },
    },


    //dev-trupti on 23-10-2024
    scrollTable: {
        flex: '82% !important',
        width: "100% !important",
        overflowX: 'auto !important',
        marginLeft: '2% !important',
        marginRight: '1% !important',
        overflowY: 'hidden !important'
    },
    // srini - 21/11/24
    cllIcnClr: {
        color: '#7DAA1C !important',
        '& .MuiSvgIcon-root': {
            color: '#7DAA1C !important',
        }
    },

    edtIcnClr: { //dev-trupti on 26-11-2024
        color: '#edd682 !important',
        '& .MuiSvgIcon-root': {
            color: '#edd682 !important',
        }
    },

    intSelText: {     // kartik - 10-01-2025
        color: '#000000 !important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },

    select: {
        color: '#000000 !important',
        width: '210px !important',
        fontFamily: 'cardiuma-regular ! important',
        background: '#ffffff !important',
    },

    inputColor: {
        color: '#000000 !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },
    inputColor1: {
        color: '#ffffff !important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important',
        fontWeight: 500
    },
    select1: {
        color: '#ffffff !important',
        width: '210px !important',
        fontFamily: 'cardiuma-regular ! important',
        background: '#131E2E !important',
    },

    intSelText1: {     // kartik - 10-01-2025
        color: '#000000 !important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important',
        fontWeight: 500,

    },
})

export default styles